import type { HekateDisplayField, HekateDisplayForm } from '@onshape/www-inertia';
import FieldUtil from '../fields/FieldUtil';
import type { SetupContext } from 'vue';

/** Generic `<input>` like field abstract coordinator, most fields will extend this. */
abstract class FormFieldCoordinator {
  protected field: Ref<HekateDisplayField>;

  protected modelValue: Ref<string>;

  protected context: SetupContext;

  protected formDefinition: Ref<HekateDisplayForm | null>;

  constructor({
    field,
    modelValue,
    context,
    formDefinition,
  }: {
    field: Ref<HekateDisplayField>;
    modelValue: Ref<string>;
    context: SetupContext;
    formDefinition: Ref<HekateDisplayForm | null>;
  }) {
    this.field = field;
    this.modelValue = modelValue;
    this.context = context;
    this.formDefinition = formDefinition;
  }

  public buildBubbleModel(): WritableComputedRef<string | boolean> {
    const bubbleModel = FieldUtil.bubbleModel({
      get: () => this.modelValue.value,
      emitter: this.context,
    });
    return bubbleModel;
  }
}

export default FormFieldCoordinator;
